const isProduction = process.env.NODE_ENV === 'production';

export const error = (err) => {
    if (!isProduction) console.error(err);
};

export const kebabCase = string => string.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/\s+/g, '-').toLowerCase();

export const getQueryParams = (name, url) => {
    if (!url) url = window.location.href;
    name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
    var regexS = "[\\?&]" + name+ "=([^&#]*)";
    var regex = new RegExp(regexS);
    var results = regex.exec(url);
    return results == null ? null : results[1];
};

export const log = (message, ...args) => {
    if (!isProduction) console.log(message, args);
};

export const add = (array, value) => {
  if (array.indexOf(value) === -1) {
    array.push(value);
  }
};

export const remove = (array, value) => {
  var index = array.indexOf(value);
  if (index !== -1) {
    array.splice(index, 1);
  }
};